import React, { useState } from "react";
// import Stock from './StockCount.js'
export default function HeaderName() {
  const [hide, setHide] = useState(false);

  const divStyles1 = {
    textShadow: "1px 1px 2px grey",
  };

  const handleHide = () => {
    setHide(!hide);
  };
  const Role = localStorage.getItem("role");
  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      <div className="title w-100">
        {Role === "stockController" ? (
          <h3 style={divStyles1}>Stock Controller</h3>
        ) : (
          <h3 style={divStyles1}>Finance & Admin Module</h3>
        )}
      </div>

      <ul className="navbar-nav ml-auto"></ul>
    </nav>
  );
}
